import clsx from "clsx";

/** Thin progress bar with an accessible value; the label next to it carries the numbers. */
export function ProgressBar({ value, max, className, label }: { value: number; max: number; className?: string; label?: string }) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 100;
  return (
    <div className={clsx("h-2 w-full overflow-hidden rounded-full bg-surface-2", className)} role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-label={label}>
      <div className={clsx("h-full rounded-full transition-[width] duration-300", pct >= 100 ? "bg-ok" : "bg-brand")} style={{ width: `${Math.min(100, Math.max(0, pct))}%` }} />
    </div>
  );
}
